import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/ccev-logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "relative flex flex-col justify-center h-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-20 w-auto max-h-full max-w-full object-contain ml-auto mr-3 flex-shrink-0",
    src: _imports_0,
    alt: "Corpus Coranicum e.V. Logo"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: '/' + _ctx.$route.params.lang
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["to"]))
}